import YTPlayer from 'yt-player';

export default class youtube{

    getVideo(){

        const _that = this;
        
        const frames = document.getElementsByClassName('frameYoutubeLazy');

        for(const box of frames){

            box.addEventListener('click', function(e){
                e.preventDefault();

                let target = e.target as HTMLElement | null;

                if(target != null){
                    
                    let targetParent: HTMLElement = target.parentElement as HTMLElement;

                    let el_id: string = targetParent.id;
                    let data_id: string = targetParent.getAttribute("data-id")!;

                    _that.youtube(el_id, data_id);

                }
              
            });

        }

    }

    /**
     * Play video
     * @param id 
     * @param idVideo 
     */
    protected youtube(id: string, idVideo: string){

        if(id != null){
            
            const elId = '#' + id;

            const player = new YTPlayer(elId, {
                host: 'https://www.youtube-nocookie.com',
                modestBranding: false,
                related: false,
                autoplay: true
            })

            player.load(idVideo);

            player.on('unstarted', () => player.play());
            
        }
        
    }

}